import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { ASSETS } from "../../data/content";

export default function SoyJordi() {
  return (
    <section data-testid="act-soy-jordi" className="relative bg-[#050505] py-24 md:py-32 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          {/* Foto cinematográfica */}
          <motion.div
            initial={{ opacity: 0, scale: 1.04 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-5"
          >
            <div className="relative aspect-[4/5] overflow-hidden border border-white/[0.06]">
              <img
                src={ASSETS.coachTraining}
                alt="Jordi Betoret entrenando a un cliente"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505]/50 via-transparent to-transparent" />
            </div>
          </motion.div>

          {/* Texto */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-7 lg:pl-4"
          >
            <span className="block font-display text-[10px] tracking-[0.4em] uppercase text-[#D4AF37] mb-7">
              Detrás de Elite Coaching
            </span>
            <h2 className="font-serif text-white leading-[1.05] tracking-tight text-4xl sm:text-5xl md:text-6xl">
              Soy <span className="italic gold-text">Jordi Betoret.</span>
            </h2>

            <div className="mt-9 space-y-5 font-display font-light text-white/75 text-base md:text-lg leading-relaxed max-w-[52ch]">
              <p>
                Durante años pensé que transformar un cuerpo dependía únicamente del
                entrenamiento y la alimentación. Con el tiempo descubrí que el verdadero
                problema nunca era ese.
              </p>
              <p>
                La mayoría de personas ya saben lo que tienen que hacer. El problema
                aparece cuando llegan el estrés, el trabajo, la falta de tiempo o la
                falta de motivación.
              </p>
              <p>
                Por eso nació Elite Coaching. No para darte otra dieta, sino para
                ayudarte a convertirte en la persona que mantiene sus compromisos incluso
                cuando no tiene ganas.
              </p>
              <p className="text-white/90">
                Porque cuando cambias tu identidad, el cuerpo deja de ser el objetivo y
                se convierte en la consecuencia.
              </p>
            </div>

            {/* Ficha profesional discreta */}
            <div className="mt-10 pt-7 border-t border-white/10 max-w-[52ch]">
              <p className="font-display text-sm tracking-[0.18em] uppercase text-white/85">Jordi Betoret</p>
              <p className="font-display text-xs text-white/50 mt-1">Fundador de Elite Coaching</p>
              <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2">
                {["Nutricionista", "Entrenador personal", "Transformación física y cambio de hábitos"].map((c) => (
                  <span key={c} className="inline-flex items-center gap-2 font-display text-xs text-white/55">
                    <Check size={13} className="text-[#D4AF37]" />
                    {c}
                  </span>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
